import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('trip_package_id')
];

const config: IFormConfig = { 
	title: 'Aggiungi pacchetto',
	fields: formFields 
};

export default config;
